import { UnderlineOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

import { useSelectionTextFormat } from '../../hooks/useSelectionTextFormat'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const UnderlineButton = () => {
  const [underline, toggleUnderline] = useSelectionTextFormat('underline')
  return (
    <MenuButton
      actived={underline}
      tooltip={
        <Flex vertical align='center'>
          <span>下划线</span>
          <span>{SHORTCUTS.UNDERLINE}</span>
        </Flex>
      }
      onClick={toggleUnderline}
    >
      <UnderlineOutlined />
    </MenuButton>
  )
}
